import React from "react";
import { ActivePartnerContext } from "./context";

export const useActivePartnerProvider = () => {
  const context = React.useContext(ActivePartnerContext);
  if (context === undefined) {
    throw new Error(
      "useCurrentPartnerProvider must be used within a CurrentPartnerProvider"
    );
  }
  return context;
};
